import { addTypesafeDoc } from './vacature-filters.helpers';

/**
 * Gather searchable objects and add them to the index
 *
 * @param  {any} index
 * @returns void
 */
function getSearchableObjects(index: any) {
  const vacaturesWrapper = <HTMLDivElement>document.querySelector('.vacatures');
  if (!vacaturesWrapper) {
    console.warn('Vcature container not found, unable to initialize search');
    return;
  }
  const vacatures = <NodeListOf<HTMLDivElement>>vacaturesWrapper.querySelectorAll('.vacature-card');
  if (!vacatures || !vacatures.length) {
    console.warn('No vacatures found, unable to initialize search');
    return;
  }

  vacatures.forEach((vacature) => {
    // Decontruct dataset
    const id = parseInt(vacature.dataset.id, 10);
    const { title, excerpt } = vacature.dataset;
    const tags = JSON.parse(vacature.dataset.tags);
    const terms = JSON.parse(vacature.dataset.terms);

    // Create doc object
    const doc: VacatureDoc = {
      id,
      title,
      tags,
      terms,
      description: excerpt,
    };

    // Add doc to index
    addTypesafeDoc(index, doc);
  });
}

/**
 * Create the base index for searching
 *
 * @param  {Function} elasticlunr
 */
export function createIndex(elasticlunr: Function) {
  const index = elasticlunr(function () {
    this.addField('id');
    this.addField('title');
    this.addField('tags');
    this.addField('description');
    this.addField('terms');
    // this.addField('location'); ? Location may be added at a later stage
  });

  getSearchableObjects(index);

  return index;
}
